/** One return to the tab sends both `visibilitychange` and `focus`, within this time. */
export const TAB_RESUME_SIGNALS_WINDOW_MS = 1_000;

/**
 * Tells the first signal of a return to the tab from the ones that come with
 * it: the resume (a token push and a resync of every store) runs once, not
 * twice, and the analytics charts do not reload twice (PT-6804).
 */
export function createTabResumeGate(now: () => number = Date.now): () => boolean {
  let lastResumeAt = -Infinity;
  return function isNewResume(): boolean {
    const at = now();
    if (at - lastResumeAt < TAB_RESUME_SIGNALS_WINDOW_MS) {
      return false;
    }
    lastResumeAt = at;
    return true;
  };
}
